import * as types from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const selectedGuidePage = (state = false, action) => {
  console.log('GUIDE - reducer fired: selected guide page', action.page)
  switch (action.type) {
    case types.SET_GUIDE_PAGE:
      return action.page;
    default:
      return state;
  }
}

export default selectedGuidePage;









// WEBPACK FOOTER //
// ./src/store/reducers/guide.js